export default __webpack_public_path__ + "static/media/logoMult.4ddf2412.png";